import { z } from 'zod';
import { imageAnnotationZod } from 'packages/lib/api/annotations/contract/image-annotation';

export const imageDataZod = z.object({
  token: z.string(),
  logToken: z.string().nullable(),
  sampleToken: z.string().nullable(),
  sampleGroupToken: z.string().nullable(),
  channel: z.string().nullable(),
  sensorToken: z.string().nullable(),
  filename: z.string().nullable(),
  timestamp: z.number().int().nonnegative(),
  positionX: z.number(),
  positionY: z.number(),
  positionZ: z.number(),
  quaternionW: z.number(),
  quaternionX: z.number(),
  quaternionY: z.number(),
  quaternionZ: z.number(),
  properties: z
    .string()
    .nullable()
    .or(
      z.object({
        height: z.number(),
        width: z.number(),
        raw: z.string(),
        type: z.string(),
      })
    ),
  width: z.number().int().nonnegative(),
  height: z.number().int().nonnegative(),
  fileSize: z.number().int().nonnegative(),
  format: z.literal('Unknown'),
  annotations: z.array(imageAnnotationZod).optional(),
});

export const imageDataRespZod = z.array(imageDataZod);

export type ImageData = z.infer<typeof imageDataZod>;
export type ImageDataResp = z.infer<typeof imageDataRespZod>;

export const isImageData = (sample: unknown): sample is ImageData =>
  imageDataZod.safeParse(sample).success;
